import { CloudStoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useStorePickerContext } from "../../storePicker.context";
import { StorePickerType } from "../../types/storePickerType.enum";
export const StorePickerFooterComponent = () => {
    const { t } = useGranite();

    const { config } = useStorePickerContext();

    if (config.type === StorePickerType.INFO) return null;

    return (
        <div>
            <p className={cn("tw:hidden tw:md:block tw:mb-0")}>
                {config.displayStockLevel &&
                    config.filterStoreType !== CloudStoreType.DriveIn &&
                    t("general.storepicker.label.pickupTime")}
                {config.infoLink && (
                    <a
                        href={config.infoLink}
                        className={cn("tw:ml-1")}
                    >
                        {t("general.storepicker.label.aboutCNC")}
                    </a>
                )}
            </p>
            {config.type === StorePickerType.CUSTOM && (
                <config.SubmitComponent />
            )}
        </div>
    );
};
